import React from "react";
import Alert from "features/shared/alerts/components/Alert";
import { useTranslation } from "react-i18next";

const ContractProcessNoContentAlert = () => {
  const t = useTranslation("contractProcess\\contractProcess").t;

  return (
    <Alert
      alertObj={{
        alertType: "Info",
        message: t("contractProcessNoContentAlert.noContent"),
      }}
    />
  );
};

export default ContractProcessNoContentAlert;
